import { createSlice } from "@reduxjs/toolkit";
import { save_tokens_constant, asyncStatus } from "../../utils/asyncStatus";
import { check_auth, login_service_auth } from "../../services/authentication";
import {
  success_toast_message,
  error_toast_message,
} from "../../utils/toast_message";
import {
  getAllStoresAsync,
  getStoreByIdAsync,
  updateStoreStatusAsync,
} from "../../services/StoreManagementServices";
import {
  addProductAsync,
  getAllProductsAsync,
  getProductByIdAsync,
  myProductsDetailsAsync,
  updateProductAsync,
} from "../../services/ProductManagementServices";

const initialState = {
  // ADD PRODUCT >>>>>>>>>>>>>
  add_product_status: asyncStatus.IDLE,
  add_product_data: null,
  add_product_error: null,

  // GET ALL PRODUCT >>>>>>>>>>>>>
  get_all_products_status: asyncStatus.IDLE,
  get_all_products_data: null,
  get_all_products_error: null,

  // GET PRODUCT BY ID >>>>>>>>>>>>>
  get_product_by_id_status: asyncStatus.IDLE,
  get_product_by_id_data: null,
  get_product_by_id_error: null,

  // EDIT PRODUCT >>>>>>>>>>>>>
  update_product_status: asyncStatus.IDLE,
  update_product_data: null,
  update_product_error: null,

  // GET MY PRODUCT >>>>>>>>>>>>>
  get_my_product_details_status: asyncStatus.IDLE,
  get_my_product_details_data: null,
  get_my_product_details_error: null,
};

const StoreManagementSlice = createSlice({
  name: "store_management",
  initialState,
  reducers: {
    setIdleStatus(state) {
      state.login_status = asyncStatus.IDLE;
    },
    setAddProductIdleStatus(state) {
      state.add_product_status = asyncStatus.IDLE;
    },
    setUpdateProductIdleStatus(state) {
      state.update_product_status = asyncStatus.IDLE;
    },
  },
  extraReducers: (builder) => {
    // GET ALL STORES >>>>>>>>>>>>>
    builder.addCase(addProductAsync.pending, (state, action) => {
      state.add_product_status = asyncStatus.LOADING;
    });

    builder.addCase(addProductAsync.fulfilled, (state, { payload }) => {
      state.add_product_status = asyncStatus.SUCCEEDED;
      state.add_product_data = payload.data;
      success_toast_message(payload.message);
    });

    builder.addCase(addProductAsync.rejected, (state, action) => {
      state.add_product_status = asyncStatus.ERROR;
      state.add_product_error = action.error;
      error_toast_message(action.error.message);
    });

    // GET ALL STORES >>>>>>>>>>>>>
    builder.addCase(getAllProductsAsync.pending, (state, action) => {
      state.get_all_products_status = asyncStatus.LOADING;
    });

    builder.addCase(getAllProductsAsync.fulfilled, (state, { payload }) => {
      state.get_all_products_status = asyncStatus.SUCCEEDED;
      state.get_all_products_data = payload.data;
    });

    builder.addCase(getAllProductsAsync.rejected, (state, action) => {
      state.get_all_products_status = asyncStatus.ERROR;
      state.get_all_products_error = action.error;
      error_toast_message(action.error.message);
    });

    // GET STORE BY ID >>>>>>>>>>>>>
    builder.addCase(getProductByIdAsync.pending, (state, action) => {
      state.get_product_by_id_status = asyncStatus.LOADING;
    });

    builder.addCase(getProductByIdAsync.fulfilled, (state, { payload }) => {
      state.get_product_by_id_status = asyncStatus.SUCCEEDED;
      state.get_product_by_id_data = payload?.data?.product;
    });

    builder.addCase(getProductByIdAsync.rejected, (state, action) => {
      state.get_product_by_id_status = asyncStatus.ERROR;
      state.get_product_by_id_error = action.error;
      error_toast_message(action.error.message);
    });

    // EDIT STORE >>>>>>>>>>>>>
    builder.addCase(updateProductAsync.pending, (state, action) => {
      state.update_product_status = asyncStatus.LOADING;
    });

    builder.addCase(updateProductAsync.fulfilled, (state, { payload }) => {
      state.update_product_status = asyncStatus.SUCCEEDED;
      state.update_product_data = payload.data;
      success_toast_message("Store status updated successfully");
    });

    builder.addCase(updateProductAsync.rejected, (state, action) => {
      state.update_product_status = asyncStatus.ERROR;
      state.update_product_error = action.error;
      error_toast_message(action.error.message);
    });

    // EDIT STORE >>>>>>>>>>>>>
    builder.addCase(myProductsDetailsAsync.pending, (state, action) => {
      state.get_my_product_details_status = asyncStatus.LOADING;
    });

    builder.addCase(myProductsDetailsAsync.fulfilled, (state, { payload }) => {
      state.get_my_product_details_status = asyncStatus.SUCCEEDED;
      state.get_my_product_details_data = payload.data;
      
    });

    builder.addCase(myProductsDetailsAsync.rejected, (state, action) => {
      state.get_my_product_details_status = asyncStatus.ERROR;
      state.get_my_product_details_error = action.error;
      error_toast_message(action.error.message);
    });
  },
});

export const { setIdleStatus,setAddProductIdleStatus,setUpdateProductIdleStatus } = StoreManagementSlice.actions;

export default StoreManagementSlice.reducer;


